/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@material-ui/core';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import {
  Button, ButtonIcon, Input, WrapperLabel,
} from 'components/Forms';
import Layout from 'components/Layout';
import { useHttp } from 'hooks/http';
import { useToast } from 'hooks/toast';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IoMdBusiness } from 'react-icons/io';
import { useHistory, useParams } from 'react-router-dom';
import { InfoIcon } from 'styles/icons';
import getValidationErrors from 'utils/getValidationsErros';
import * as Yup from 'yup';
import {
  Container, Content, GridButtons, WrapperBtnCancel, WrapperBtnInfo, WrapperBtnSubmit,
} from './styles';

interface Params {
  id: string;
}

const PartnerProfile: React.FC = () => {
  const history = useHistory();
  const { httpPut, httpGet, loading } = useHttp();
  const formRef = useRef<FormHandles>(null);
  const labelRef = useRef<HTMLLabelElement>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const { addToast } = useToast();
  const { id } = useParams<Params>();

  useEffect(() => {
    async function loadPartner() {
      try {
        const { data } = await httpGet(`social-action/partners/${id}`);
        formRef.current?.setData({
          partner_name: data.partner_name,
        });
      } catch (error) {
        addToast({ title: 'Erro ao carregar parceiro', type: 'error' });
        history.push('/social-action/partners');
      }
    }

    loadPartner();
  }, [id]);

  const handleSubmit = useCallback(async (data: any) => {
    try {
      setBtnLoading(true);

      const schema = Yup.object().shape({
        partner_name: Yup.string().required('Nome do parceiro é obrigatório'),
      });

      await schema.validate(data, { abortEarly: false });

      const { status } = await httpPut(`social-action/partners/${id}`, {
        partner_name: data.partner_name,
      });

      setBtnLoading(false);

      if (status === 200) {
        addToast({ title: 'Salvo com suceso!', type: 'success' });
        formRef.current?.reset();
        history.push('/social-action/partners');
      } else {
        addToast({ title: 'Não foi possível editar o serviço' });
      }
    } catch (error) {
      setBtnLoading(false);
      if (error instanceof Yup.ValidationError) {
        const erros = getValidationErrors(error);
        formRef.current?.setErrors(erros);
      } else {
        addToast({ title: 'Erro inesperado', type: 'error' });
      }
    }
  }, [addToast, history, httpPut, id]);

  const breadcrumbs = {
    icon: IoMdBusiness,
    links: [{ path: '', title: 'Parceiros' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
        <Content>
          <UForm ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <WrapperLabel label="Editar Parceiro" xs={12}>
                <Input
                  name="partner_name"
                  style={{ textTransform: 'uppercase' }}
                />
              </WrapperLabel>
            </Grid>
            <GridButtons>
              <WrapperBtnInfo>
                <ButtonIcon
                  title="Instruções"
                  onClick={() => labelRef.current?.click()}
                >
                  <InfoIcon />
                </ButtonIcon>
              </WrapperBtnInfo>
              <WrapperBtnCancel>
                <Button
                  type="button"
                  onClick={() => { history.push('/social-action/partners'); }}
                >
                  Cancelar
                </Button>
              </WrapperBtnCancel>
              <WrapperBtnSubmit>
                <Button
                  type="submit"
                  isLoading={btnLoading}
                >
                  Enviar
                </Button>
              </WrapperBtnSubmit>
            </GridButtons>
          </UForm>
        </Content>
      </Container>
    </Layout>
  );
};

export default PartnerProfile;
